import React, { ReactNode } from 'react';

type ButtonType = 'reset' | 'submit';

interface ButtonsProps {
  children: ReactNode;
  type: ButtonType;
  color: string;
  activeColor: string;
  onClick: () => void;
}

export function FilterButton({
  children,
  type,
  color,
  activeColor,
  onClick
}: ButtonsProps) {
  return (
    <button
      data-testid="filter-button"
      type={type}
      className={`h-12 w-full rounded-full font-medium transition duration-300 ${color} hover:${activeColor} active:${activeColor}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
